export const PUBLICATIONS_FETCHING_ERROR_PREFIX = 'Problem with fetching publications';
